import helpers from '@router/helpers';
const menuId = 'comunicacao-com-instrumento';

export default [
  helpers.criarRota(menuId, 'comunicacao-com-instrumento', menuId, () =>
    import('@/views/modulos/cadastros/comunicacao_com_instrumento')
),
helpers.criarRota(menuId, 'comunicacao-com-instrumento-novo', `${menuId}/novo`, () =>
    import('@/views/modulos/cadastros/comunicacao_com_instrumento/formulario')
),
helpers.criarRota(menuId, 'comunicacao-com-instrumento-editar', `${menuId}/:id?`, () =>
    import('@/views/modulos/cadastros/comunicacao_com_instrumento/formulario'), true
),
]